module.exports = __webpack_public_path__ + "media/images/cloud-agent-suite-logo--black-9d0cec94017f7195209a12fd57a05031.svg";